/* eslint-disable sonarjs/no-duplicate-string */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { NotFoundComponent } from '@features/not-found/not-found.component';
import { CompanyWebservice } from '@webservices/company-api/company.webservice';
import { IMAGINARY_PIPE_CONFIG } from '@wizbii/angular-utilities';
import {
  CityWebservice,
  COMPANY_API_CONFIG,
  CONTACT_API_CONFIG,
  ContactWebservice,
  ContractWebservice,
  DegreeWebservice,
  FILE_API_CONFIG,
  FileWebservice,
  JOB_API_CONFIG,
  PLACE_API_CONFIG,
  SCHOOL_API_CONFIG,
} from '@wizbii/webservices';

// tslint:disable: no-duplicate-string
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./homeB/homeB.module').then((module) => module.HomeBModule),
  },
  // ********* Redirect old routes for AB test on homepage to avoid 404 *******
  {
    path: FeaturesRoutingEnum.HomeB,
    redirectTo: '/',
  },
  {
    path: FeaturesRoutingEnum.HomeC,
    redirectTo: '/',
  },
  // ***********************************************************
  {
    path: FeaturesRoutingEnum.Events,
    loadChildren: () => import('./events/events.module').then((module) => module.EventsModule),
  },
  {
    path: FeaturesRoutingEnum.Jobs,
    loadChildren: () => import('./jobs/jobs.module').then((module) => module.JobsModule),
  },
  {
    path: FeaturesRoutingEnum.SummerJobs,
    loadChildren: () => import('./summer-jobs/summer-jobs.module').then((module) => module.SummerJobsModule),
  },
  {
    path: FeaturesRoutingEnum.StudentJobs,
    loadChildren: () => import('./student-jobs/student-jobs.module').then((module) => module.StudentJobsModule),
  },
  {
    path: FeaturesRoutingEnum.Internships,
    loadChildren: () => import('./internships/internships.module').then((module) => module.InternshipsModule),
  },
  {
    path: FeaturesRoutingEnum.Apprentice,
    loadChildren: () => import('./apprentice/apprentice.module').then((module) => module.ApprenticeModule),
  },
  {
    path: FeaturesRoutingEnum.CGU,
    loadChildren: () => import('./legal/legal.module').then((module) => module.LegalModule),
  },
  {
    path: FeaturesRoutingEnum.Privacy,
    loadChildren: () => import('./legal/legal.module').then((module) => module.LegalModule),
  },
  {
    path: FeaturesRoutingEnum.Cookies,
    loadChildren: () => import('./legal/legal.module').then((module) => module.LegalModule),
  },
  {
    path: FeaturesRoutingEnum.LegalMentions,
    loadChildren: () => import('./legal/legal.module').then((module) => module.LegalModule),
  },
  {
    path: FeaturesRoutingEnum.Accessibility,
    loadChildren: () => import('./legal/legal.module').then((module) => module.LegalModule),
  },
  {
    path: FeaturesRoutingEnum.Employers,
    loadChildren: () => import('./employer/employer.module').then((module) => module.EmployerModule),
  },
  {
    path: FeaturesRoutingEnum.Young,
    loadChildren: () => import('./young/young.module').then((module) => module.YoungModule),
  },
  {
    path: FeaturesRoutingEnum.Companies,
    loadChildren: () => import('./companies/companies.module').then((module) => module.CompaniesModule),
  },
  {
    path: FeaturesRoutingEnum.CivicService,
    loadChildren: () => import('./civic-service/civic-service.module').then((module) => module.CivicServiceModule),
  },
  {
    path: FeaturesRoutingEnum.Volunteer,
    loadChildren: () => import('./volunteer/volunteer.module').then((module) => module.VolunteerModule),
  },
  {
    path: FeaturesRoutingEnum.Promo1618,
    loadChildren: () =>
      import('./promotion-young/promotion-young.module').then((module) => module.PromotionYoungModule),
  },
  {
    path: FeaturesRoutingEnum.Article,
    loadChildren: () => import('./article/article.module').then((module) => module.ArticleModule),
  },
  {
    path: FeaturesRoutingEnum.Visiotalent,
    loadChildren: () => import('./visiotalent/visiotalent.module').then((module) => module.VisiotalentModule),
  },
  {
    path: FeaturesRoutingEnum.PoleEmploiMaintenance,
    loadChildren: () =>
      import('./maintenance-pole-emploi/maintenance-pole-emploi.module').then(
        (module) => module.MaintenancePoleEmploiModule
      ),
  },
  {
    path: FeaturesRoutingEnum.AccessHelps,
    loadChildren: () => import('./access-helps/access-helps.module').then((module) => module.AccessHelpsModule),
  },
  {
    path: FeaturesRoutingEnum.CreateCompany,
    loadChildren: () => import('./create-company/create-company.module').then((module) => module.CreateCompanyModule),
  },
  {
    path: FeaturesRoutingEnum.Mentoring,
    loadChildren: () => import('./mentoring/mentoring.module').then((module) => module.MentoringModule),
  },
  {
    path: FeaturesRoutingEnum.Trainings,
    loadChildren: () => import('./trainings/trainings.module').then((module) => module.TrainingsModule),
  },
  {
    path: FeaturesRoutingEnum.TrainingObligation,
    loadChildren: () =>
      import('./training-obligation/training-obligation.module').then((module) => module.TrainingObligationModule),
  },
  {
    path: FeaturesRoutingEnum.Commitment,
    loadChildren: () => import('./commitment/commitment.module').then((module) => module.CommitmentModule),
  },
  {
    path: FeaturesRoutingEnum.Volunteer,
    loadChildren: () => import('./volunteer/volunteer.module').then((module) => module.VolunteerModule),
  },
  {
    path: FeaturesRoutingEnum.Sitemap,
    loadChildren: () => import('./sitemap/sitemap.module').then((module) => module.SitemapModule),
  },
  {
    path: FeaturesRoutingEnum.JobDating,
    loadChildren: () => import('./jobdating/jobdating.module').then((module) => module.JobdatingModule),
  },
  {
    path: FeaturesRoutingEnum.YouthInfoCenter,
    loadChildren: () =>
      import('./youth-info-center/youth-info-center.module').then((module) => module.YouthInfoCenterModule),
  },
  {
    path: FeaturesRoutingEnum.Partners,
    loadChildren: () => import('./partners/partners.module').then((module) => module.PartnersModule),
  },
  {
    path: FeaturesRoutingEnum.Marseille,
    loadChildren: () => import('./marseille/marseille.module').then((module) => module.MarseilleModule),
  },
  {
    path: FeaturesRoutingEnum.CEJ,
    loadChildren: () => import('./cej-v2/cej-v2.module').then((module) => module.CejV2Module),
  },
  {
    path: 'cej',
    redirectTo: `/${FeaturesRoutingEnum.CEJ}`,
  },
  {
    path: FeaturesRoutingEnum.DiagorienteCv,
    loadChildren: () => import('./diagoriente-cv/diagoriente-cv.module').then((module) => module.DiagorienteCvModule),
  },
  {
    path: FeaturesRoutingEnum.DiagorienteInterests,
    loadChildren: () =>
      import('./diagoriente-interests/diagoriente-interests.module').then(
        (module) => module.DiagorienteInterestsModule
      ),
  },
  {
    path: FeaturesRoutingEnum.Eures,
    loadChildren: () => import('./eures/eures.module').then((module) => module.EuresModule),
  },
  {
    path: FeaturesRoutingEnum.SeoCivicService,
    loadChildren: () =>
      import('./seo-civic-service/seo-civic-service.module').then((module) => module.SeoCivicServiceModule),
  },
  {
    path: FeaturesRoutingEnum.SeoLocalMission,
    loadChildren: () =>
      import('./seo-local-mission/seo-local-mission.module').then((module) => module.SeoLocalMissionModule),
  },
  {
    path: FeaturesRoutingEnum.pfue,
    loadChildren: () => import('./pfue/pfue.module').then((module) => module.PfueModule),
  },
  {
    path: FeaturesRoutingEnum.News,
    loadChildren: () => import('./news-page/news-page.module').then((module) => module.NewsPageModule),
  },
  {
    path: FeaturesRoutingEnum.EmployerSpace,
    loadChildren: () => import('./employer-space/employer-space.module').then((module) => module.EmployerSpaceModule),
  },
  {
    path: FeaturesRoutingEnum.NotFound,
    component: NotFoundComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { unhandled404: true },
  },
];

@NgModule({
  declarations: [NotFoundComponent],
  imports: [RouterModule.forChild(routes), ExternalLinkDirectiveModule],
  providers: [
    CityWebservice,
    {
      provide: PLACE_API_CONFIG,
      useValue: {
        baseUrl: environment.api.place,
      },
    },
    ContractWebservice,
    {
      provide: JOB_API_CONFIG,
      useValue: {
        baseUrl: environment.api.job,
      },
    },
    DegreeWebservice,
    {
      provide: SCHOOL_API_CONFIG,
      useValue: {
        baseUrl: environment.api.school,
      },
    },
    FileWebservice,
    {
      provide: FILE_API_CONFIG,
      useValue: {
        baseUrl: environment.api.file,
        googleStorageUrl: environment.api.googleStorage,
        wizbiiFilesBucket: environment.wizbiiFiles,
      },
    },
    ContactWebservice,
    {
      provide: CONTACT_API_CONFIG,
      useValue: {
        appId: environment.applicationId,
        baseUrl: environment.api.contact,
      },
    },
    CompanyWebservice,
    {
      provide: COMPANY_API_CONFIG,
      useValue: {
        appId: environment.applicationId,
        baseUrl: environment.api.company,
      },
    },
    {
      provide: IMAGINARY_PIPE_CONFIG,
      useValue: {
        imaginaryUrl: environment.api.imaginary,
      },
    },
  ],
})
export class FeaturesModule {}
